const common = {
	lightGrey: '#F7F7F7',
	base: '#fff',
	textPrimary: '#36393B',
	textSecondary: 'rgba(51, 51, 51, 0.4)',
	font: {
		weight: {
			regular: 400,
			semiBold: 600,
			bold: 700,
		},
	},
};

export const happy = {
	...common,
	accent: '#ABD562',
	accentLight: '#F3F9E9',
};

export const inlove = {
	...common,
	accent: '#FF84B7',
	accentLight: '#FFEEF5',
};

export const relaxed = {
	...common,
	accent: '#75E2D7',
	accentLight: '#EBFBFA',
};

export const pleased = {
	...common,
	accent: '#F9D629',
	accentLight: '#FEF9E0',
};

export const neutral = {
	...common,
	accent: '#52D3FC',
	accentLight: '#E6F9FF',
};

export const sad = {
	...common,
	accent: '#B49E72',
	accentLight: '#F5F1EB',
};

export const confused = {
	...common,
	accent: '#8C5BFF',
	accentLight: '#EFE8FF',
};

export const angry = {
	...common,
	accent: '#F36D6D',
	accentLight: '#FEEAEA',
};
